import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, AlertCircle, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('not_found');
      return;
    }
    axios.get(`${API}/unsubscribe`, { params: { token } })
      .then(({ data }) => {
        setStatus(data.status);
        if (data.email) setEmail(data.email);
      })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <SEO path="/abmelden" title="Newsletter abmelden" description="Newsletter-Abmeldung" noindex />
      <div className="w-full max-w-lg p-10 rounded-3xl border border-[#d4b574]/15 bg-[#0e0e0c] text-center">
        {status === 'loading' && (
          <p className="text-[#9a9285]">Einen Moment…</p>
        )}
        {(status === 'ok' || status === 'already') && (
          <>
            <CheckCircle2 className="text-[#9ce7a8] mx-auto" size={42} />
            <h1 className="font-serif-display text-3xl text-[#f5efe3] mt-5">
              {status === 'already' ? 'Du warst bereits abgemeldet' : 'Du wurdest erfolgreich abgemeldet'}
            </h1>
            <p className="text-[#cfc6b5] mt-4">
              {email && <>Die Adresse <span className="text-[#e8d5a8]">{email}</span> erhält keine weiteren Newsletter mehr.<br/></>}
              Schade, dass du uns verlässt! Falls du es dir anders überlegst, kannst du dich jederzeit wieder anmelden.
            </p>
          </>
        )}
        {status === 'not_found' && (
          <>
            <AlertCircle className="text-[#e8b4a8] mx-auto" size={42} />
            <h1 className="font-serif-display text-3xl text-[#f5efe3] mt-5">Link ungültig</h1>
            <p className="text-[#cfc6b5] mt-4">Der Abmeldelink ist ungültig oder abgelaufen.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <AlertCircle className="text-[#e8b4a8] mx-auto" size={42} />
            <h1 className="font-serif-display text-3xl text-[#f5efe3] mt-5">Etwas ist schiefgelaufen</h1>
            <p className="text-[#cfc6b5] mt-4">Bitte versuche es später erneut oder kontaktiere uns direkt.</p>
          </>
        )}
        <Link to="/" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#d4b574] text-[#0a0a0c] font-medium hover:bg-[#e8d5a8] transition-colors">
          Zur Startseite <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
